<template>
  <kst-page-export
    :catalog="DlvSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithList"
      :label="Info.Export.List.Excel.Option.List"
    />
    <kst-check 
      v-model="userData.WithItems"
      :label="Info.Export.List.Excel.Option.DeliveryItem"
    />
  </kst-page-export>
</template>

<script>
import DlvSearchCatalog from "../DlvSearchCatalog.js";
import Info from "../DlvInfo.js";
import Model from "../DlvModel.js";
import Services from "../../../services/Api/DeliveryServices.js";

import Export from "./DlvExL_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    DlvSearchCatalog: DlvSearchCatalog,
    Info: Info,
    Model: Model,
    searchData: {
      Search: "",
      ClientName: "",
      ClientID: null, 
      Date: null,
      StatusID: null,
      WarehouseID: null
    },
    userData: {
      WithList: true,
      WithItems: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = this.getListOptions();
      const config = Services.getExportList(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.userData.WithList = true;
      this.userData.WithItems = true;
    },

    getListOptions() {
      const clientId = this.$kst.Out.getInteger(this.searchData.ClientID);
      const clientName = clientId === null
        ? this.$kst.Out.getString(this.searchData.Client) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.DepartureDate[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.DepartureDate[1]),
        client: clientId,
        clientname: clientName,
        status: this.$kst.Search.getValue(this.searchData.Status),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields,
        withitems: this.$kst.Out.getBoolean(this.userData.WithItems)
      };
    }
  }
}
</script>